export class ServiceOrdering {
  /** Создания заказа в eShop на основе заказа CRM */
  CreateOrderingOnSaleOrderCrm: string;

  /** Получить данные для sale оплаты заказа */
  GetDataOrderingForSalePayment: string;

  /** Получение списка р/с по параметрам */
  GetAccountsOnParameters: string;

  /** Создания платежа в интернет-эквайринге на основе параметров заказа */
  CreatePaymentInternetAcquiringOnParametersOrdering: string;

  /** Получение основной информации о заказе */
  GetOrderingInfo: string;

  /** Получение данных пред-заказа */
  GetPreOrdering: string;

  /** Получение данных из файла конфигурации */
  GetConfig: string;

  /** Создание заказа версия 2 */
  CreateOrderingV2: string;

  /** Получить id заказа по Id предзаказа */
  GetOrderingIdOnPreOrderingId: string;

  /** Получение url на переход в интернет-эквайринг для ранее созданной заявки */
  GetPayUrlInternetAcquiringOnOrdering: string;

  /** Получение url на переход в интернет-эквайринг для ранее созданной заявки версии 2 */
  GetPayUrlInternetAcquiringOnOrderingV2: string;

  /** Получить список промокодов Тинькоффа */
  GetInstallmentTinkoffList: string;

  /** Получить р/с для Тинькофф рассрочку */
  GetPaymentAccountForTinkoffInstallment: string;

  /** Обновление поля "время жизни заказа" заказа частичной оплаты */
  UpdateOrderingPrePaymentLifeTime: string;

  /** Получить частичный заказ по ид */
  GetOrderingPrePayment: string;

  /** Получение суммы заказа с суммой частично оплаченного */
  GetSumOrderingWithSumPaidPartialPayment: string;

  /** Получить информацию об оплаченной и оставшейся сумме заказа CRM */
  GetInfoPaymentOrderById: string;

  /** Получить р/с по типу оплаты и типам прайс-листам */
  GetPaymentAccountForPartnersId: string;

  /** Создания заказа в eShop на основе заказа CRM */
  CreateOrderBasedOnOrderCrm: string;

  /** Проверка на существования привязанного заказа eShop с CRM */
  CheckForExistsLinkedOrderToCrm: string;

  /** Получить счет для печати */
  GetPrintBill: string;

  constructor(url: string) {
    this.CreateOrderingOnSaleOrderCrm = `${url}/api/v1/ordering/createorderingonsaleordercrm`;
    this.GetDataOrderingForSalePayment = `${url}/api/v1/ordering/getdataorderingforsalepayment`;
    this.GetAccountsOnParameters = `${url}/api/v1/ordering/getaccountsonparameters`;
    this.CreatePaymentInternetAcquiringOnParametersOrdering = `${url}/api/v1/ordering/createpaymentinternetacquiringonparametersordering`;
    this.GetOrderingInfo = `${url}/api/v1/ordering/getorderinginfo`;
    this.GetConfig = `${url}/api/v1/diagnostics/getconfig`;
    this.GetPreOrdering = `${url}/api/v1/ordering/getpreordering`;
    this.CreateOrderingV2 = `${url}/api/v1/ordering/createorderingv2`;
    this.GetOrderingIdOnPreOrderingId = `${url}/api/v1/ordering/getorderingidonpreorderingid`;
    this.GetPayUrlInternetAcquiringOnOrdering = `${url}/api/v1/ordering/get-pay-url-internet-acquiring-on-ordering`;
    this.GetPayUrlInternetAcquiringOnOrderingV2 = `${url}/api/v1/ordering/get-pay-url-internet-acquiring-on-ordering-v2`;
    this.GetInstallmentTinkoffList = `${url}/api/v1/ordering/get-installment-tinkoff-list`;
    this.GetPaymentAccountForTinkoffInstallment = `${url}/api/v1/ordering/get-payment-account-for-tinkoff-installment`;
    this.UpdateOrderingPrePaymentLifeTime = `${url}/api/v1/ordering/update-ordering-pre-payment-life-time`;
    this.GetOrderingPrePayment = `${url}/api/v1/ordering/get-ordering-pre-payment`;
    this.GetSumOrderingWithSumPaidPartialPayment = `${url}/api/v1/ordering/get-sum-ordering-with-sum-paid-partial-payment`;
    this.GetInfoPaymentOrderById = `${url}/api/v1/ordering/get-info-payment-order-by-id`;
    this.GetPaymentAccountForPartnersId = `${url}/api/v1/ordering/getpaymentaccountforpartnersid`;
    this.CreateOrderBasedOnOrderCrm = `${url}/api/v1/ordering/create-order-based-on-order-crm`;
    this.CheckForExistsLinkedOrderToCrm = `${url}/api/v1/ordering/check-for-exists-linked-order-to-crm`;
    this.GetPrintBill = `${url}/api/v1/ordering/GetPrintBill`;
  }
}